import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 grid-rows-2 gap-x-4 gap-y-4" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = {
  value: null,
  disabled: "",
  selected: ""
}
const _hoisted_4 = ["value"]

import {
  reactive,
  ref,
  onMounted,
  computed,
  PropType,
} from "vue";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Modal from "@/components/common/Modal.vue";
import { useStore } from "vuex";
import { UserGetters } from "@/store/modules/user/getters";
import { UserActions } from "@/store/modules/user/actions";
import Button from "@/components/common/Button.vue";
import { DocumentDataService } from "@/services";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  documentId: {
    type: String,
    required: true,
  },
  mode: {
    type: String,
    default: "VIEW",
  },
  excludedUserIds: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
},
  emits: ["hide", "submit"],
  setup(__props, { emit }) {

const props = __props



const modalTitle = computed(() =>
  props.mode === "CO_EDITOR"
    ? t("documentAccess.grantCoEditor")
    : t("documentAccess.grantAccess")
);

const state = reactive({
  userId: null,
});
const rules = {
  userId: { required },
};

const store = useStore();

const submitted = ref(false);
const v$ = useVuelidate(rules, state);

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  try {
    if (props.mode === "CO_EDITOR") {
      await DocumentDataService.addCoEditor(props.documentId, state.userId!);
    } else {
      await DocumentDataService.addViewAccess(props.documentId, state.userId!);
    }
    emit("submit");
  } catch (e) {
    console.error(e);
  }
}

const usersDataProvider = computed(
  () => store.getters[UserGetters.GET_DATA_PROVIDER]
);
const availableUsers = computed(() => {
  const excludedUserIds = new Set(props.excludedUserIds);
  return (usersDataProvider.value?.items ?? []).filter(
    (user: { id: string }) => !excludedUserIds.has(user.id)
  );
});

onMounted(async () => {
  await store.dispatch(UserActions.FETCH_DATA_PROVIDER);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hide'))),
    show: __props.show,
    title: _unref(modalTitle)
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", {
              class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).userId.$invalid && submitted.value }]),
              for: "user-id"
            }, _toDisplayString(_unref(t)("documentAccess.user")), 3),
            _withDirectives(_createElementVNode("select", {
              id: "user-id",
              class: _normalizeClass(["input-form w-full", {
              'p-invalid': _unref(v$).userId.$invalid && submitted.value,
            }]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).userId.$model) = $event))
            }, [
              _createElementVNode("option", _hoisted_3, _toDisplayString(_unref(t)("documentAccess.selectUser")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableUsers), (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: user.id,
                  key: user.id
                }, _toDisplayString(user.surname) + " " + _toDisplayString(user.name), 9, _hoisted_4))
              }), 128))
            ], 2), [
              [_vModelSelect, _unref(v$).userId.$model]
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(Button, { type: "submit" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.apply")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})